import { useTranslation } from 'react-i18next'

const MessageAlert = ({ icon, text }) => {
  const { t } = useTranslation()
  return (
    <div className="mg-message-alert">
      <div className="mg-message-alert-icon">{icon && <span className="material-icons notranslate">{icon}</span>}</div>
      <div className="mg-message-alert-text">{text && t(text)}</div>
    </div>
  )
}

export default MessageAlert
